import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { config } from '../config';

@Injectable({ providedIn: 'root' })
export class AthleteClassesService {
  private readonly apiBaseUrl = config.apiUrl;

  constructor(private http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    return new HttpHeaders({ Authorization: token ? `Bearer ${token}` : '' });
  }

  getAthleteClasses(athleteId: number) {
    return this.http.get<any[]>(`${this.apiBaseUrl}/athletes/${athleteId}/classes`, {
      headers: this.getAuthHeaders(),
    });
  }

  createAthleteClass(athleteId: number, payload: any) {
    return this.http.post(`${this.apiBaseUrl}/athletes/${athleteId}/classes`, payload, {
      headers: this.getAuthHeaders(),
    });
  }

  updateAthleteClass(athleteId: number, id: number, payload: any) {
    return this.http.patch(`${this.apiBaseUrl}/athletes/${athleteId}/classes/${id}`, payload, {
      headers: this.getAuthHeaders(),
    });
  }

  deleteAthleteClass(athleteId: number, id: number) {
    return this.http.delete(`${this.apiBaseUrl}/athletes/${athleteId}/classes/${id}`, {
      headers: this.getAuthHeaders(),
    });
  }

  // ✅ گزارش: تمدیدهای نزدیک
  getExpiringEnrollments(days = 3) {
    const params = new HttpParams().set('days', String(days));
    return this.http.get<any[]>(`${this.apiBaseUrl}/athletes/expiring-enrollments`, {
      headers: this.getAuthHeaders(),
      params,
    });
  }

  // ✅ گزارش: تعداد ثبت‌نام هر کلاس
  getClassEnrollCounts(onlyActiveClasses = false) {
    const params = new HttpParams().set('onlyActiveClasses', String(onlyActiveClasses));
    return this.http.get<any[]>(`${this.apiBaseUrl}/athletes/class-enroll-counts`, {
      headers: this.getAuthHeaders(),
      params,
    });
  }
}
